<template>
  <div class="contents component-dakoku-panel" v-if="authStore.hasPermission(PermissionConst.GET_DAKOKU)">
    <h2>打刻パネル</h2>
    <section class="user-info">
      <section class="location-panel">
        <div class="location">
          <label>打刻を行う就業場所：</label>
          <select v-model="selectedSyuugyouBasyoOption" @change="changeSyuugyouBasyo"
            :disabled="syuugyouBasyoOptions.length < 1">
            <option v-for="syuugyoubasyo in syuugyouBasyoOptions" :value="syuugyoubasyo"
              :selected="selectedSyuugyouBasyoOption?.koyou_id === syuugyoubasyo.koyou_id">{{ syuugyoubasyo.label }}
            </option>
            <option v-if="syuugyouBasyoOptions.length < 1" :value="null">選択可能な就業場所がありません</option>
          </select>
          
          <!-- MEDICA_AS-1250対応 -->
          <!-- <div class="other-syuugyou-basyo">
            <p class="link-text" @click="syuugyouBasyoModal.openSyuugyouBasyoModal()">他の就業場所を選ぶ</p>
            <modal ref="syuugyouBasyoModalRef" :title="'就業場所の選択'">
              <select-syuugyoubasyo v-on:select="selectOtherSyuugyouBasyo"
                v-on:cancel="syuugyouBasyoModal.closeSyuugyouBasyoModal()"
                :excludeSyuugyouBasyoOptions="syuugyouBasyoOptions">
              </select-syuugyoubasyo>
            </modal>
          </div> -->
          
        </div>
      </section>
    </section>

    <template v-if="isLoading || !isInit">
      <loading :isLoading="isLoading" :message="'処理中...'"></loading>
    </template>
    <section v-else class="dakoku-panels" :class="{ disabled: !dakokuData }">
      <div class="location">
        <label>就業時間：</label>
        <select v-model="selectedKoyouKeiyakuTimeOption" :disabled="koyouKeiyakuTimeOptions.length < 1">
          <option v-for="koyouKeiyakuTime in koyouKeiyakuTimeOptions" :value="koyouKeiyakuTime" :disabled="dakokuData?.koyou_keiyaku_time_id !== null"
            :selected="selectedKoyouKeiyakuTimeOption?.val === koyouKeiyakuTime.val">{{ koyouKeiyakuTime.label }}
          </option>
          <option v-if="koyouKeiyakuTimeOptions.length < 1" :value="null">選択可能な就業時間がありません</option>
        </select>
      </div>
      <div v-if="!dakokuData" class="disable-message">
        <p>打刻をするには<br>就業場所を選択してください</p>
      </div>
      <div class="buttons">
        <div class="dakoku-date">
          <p>{{ displayData.date }}</p>
          <p class="reload" @click="getDakoku()"><i class="fa-solid fa-arrows-rotate"></i><span>更新</span></p>
        </div>

        <div class="main-panel-wrapper">
          <div class="panel">
            <div class="button syukkin" v-on:click="syukkinDakoku()"
              v-bind:class="{ disable: dakokuData?.syukkin_datetime || dakokuData?.taikin_datetime || isSyouninDakoku }">
              出勤
            </div>
            <p class="time-label" v-if="displayData.syukkin">{{ displayData.syukkin }}</p>
          </div>

          <div class="panel">
            <div class="button taikin" v-on:click="taikinDakoku()"
              v-bind:class="{ disable: dakokuData?.taikin_datetime || isSyouninDakoku }">
              退勤
            </div>
            <p class="time-label" v-if="displayData.taikin">{{ displayData.taikin }}</p>
          </div>
        </div>

        <div class="kyuukei">
          <p>取得した休憩時間：{{ displayData.kyuukei }}<template v-if="dakokuData?.reported_kyuukei_times === null">
              （<span class="kyuukei-input-button" @click="inputKyuukei()">休憩時間の登録</span>）</template></p>
        </div>

        <modal ref="kyuukeiInputModalRef" :title="kyuukeiInputModalParts.title">
          <kyuukei-nyuuryoku :syuugyouBasyoId="selectedSyuugyouBasyoOption?.val"
            :koyouKeiyakuId="selectedSyuugyouBasyoOption?.koyou_id" :targetDate="targetDate()"
            v-on:send="kyuukeiInputClose($event)" v-on:cancel="kyuukeiInputCancel()">
          </kyuukei-nyuuryoku>
        </modal>
      </div>

      <div class="dakoku-menu">

        <p>
          <router-link :to="{ name: RouterConst.SHINSEI_CREATE, params: { type: OptionConst.SHINSEI_TYPE.JIKANGAI } }">
            <i class="fa-solid fa-inbox"></i>
            <span>時間外申請</span>
          </router-link>
        </p>

        <p>
          <router-link :to="{ name: RouterConst.SHINSEI_CREATE, params: { type: OptionConst.SHINSEI_TYPE.YUUKYUU } }">
            <i class="fa-solid fa-inbox"></i>
            <span>有給申請</span>
          </router-link>
        </p>

      </div>

      <div class="sub-panel-wrapper">
        <p>その他の操作</p>
        <div class="panel">
          <div class="button gaisyutsu" v-on:click="gaisyutsuDakoku()"
            v-bind:class="{ disable: dakokuData?.gaisyutsu_datetime || dakokuData?.taikin_datetime || dakokuData?.modori_datetime || isSyouninDakoku }">
            外出
          </div>
          <p class="time-label" v-if="displayData.gaisyutsu">{{ displayData.gaisyutsu }}</p>
        </div>

        <div class="panel">
          <div class="button modori" v-on:click="modoriDakoku()"
            v-bind:class="{ disable: dakokuData?.modori_datetime || dakokuData?.taikin_datetime || isSyouninDakoku }">
            戻り
          </div>
          <p class="time-label" v-if="displayData.modori">{{ displayData.modori }}</p>
        </div>
      </div>

      <!-- <div class="honnin-notes window-section">
        <h3>備考</h3>
        <div class="text">
          <p v-if="dakokuData?.honnin_notes" class="pre">{{ dakokuData.honnin_notes }}</p>
          <p v-else @click="honninNotesInputModal.openHonninNotesInputModal()" class="input-button">備考を登録する</p>
        </div>

        <div class="control">
          <p v-if="dakokuData?.honnin_notes" @click="honninNotesInputModal.openHonninNotesInputModal()"
            class="input-button">編集</p>
        </div>

        <modal ref="honninNotesInputModalRef" :title="honninNotesInputModalParts.title">
          <honnin-notes-input :notes="dakokuData?.honnin_notes" :syuugyouBasyoId="selectedSyuugyouBasyoOption?.val"
            :koyouKeiyakuId="selectedSyuugyouBasyoOption?.koyou_id" :targetDate="targetDate()"
            v-on:send="honninNotesInputSend()" v-on:cancel="honninNotesInputCancel()">
          </honnin-notes-input>
        </modal>
      </div> -->

    </section>
  </div>
</template>

<script lang="ts">
import { useDakoku } from "@/composable/dakoku/dakoku"
import { defineComponent, onMounted, ref } from "vue"
import { useDakokuInit } from "@/composable/dakoku/init"
import KyuukeiNyuuryoku from "@/components/dakoku/KyuukeiInput.vue"
import { useKyuukeiInputModal } from "@/composable/modal/kyuukei-input"
import { DialogService } from "@/service/DialogService"
import Message from "@/const/Message"
import { SweetAlertResult } from "sweetalert2"
import OptionConst from "@/const/Option"
import { RouterConst } from "@/const/Router"
import { useSyuugyouBasyoInit } from "@/composable/syuubyoubasyo/init"
import { useKoyouKeiyakuTimeInit } from "@/composable/koyoukeiyakutime/init"
import { useAuthStore } from "@/store/auth"
import { PermissionConst } from '@/const/Permission'
import SelectSyuugyoubasyo from '@/components/syuugyoubasyo/SyuugyouBasyo.vue'
import { useSyuugyouBasyoModal } from "@/composable/modal/syuugyou-basyo"
import { SyuugyouBasyoOption } from "@/types/SyuugyouBasyo"
import { useHonninNotesInputModal } from "@/composable/modal/honnin-notes-input"
import { howWeek } from "@/filters/common"
import { isNull } from "lodash"
import HonninNotesInput from '@/components/dakoku/HonninNotes.vue'

export default defineComponent({
  setup() {
    const { dakokuData, displayData, targetDate, isSyouninDakoku } = useDakokuInit()
    const { syuugyouBasyoOptions, getOptionsByDakokuAndKoyouKeiyaku, selectedSyuugyouBasyoOption } = useSyuugyouBasyoInit()
    const { koyouKeiyakuTimeOptions, getKoyouKeiyakuTimeOrShiftOptionByDate, selectedKoyouKeiyakuTimeOption } = useKoyouKeiyakuTimeInit()
    const kyuukeiInputModal = useKyuukeiInputModal()
    const syuugyouBasyoModal = useSyuugyouBasyoModal()
    const honninNotesInputModal = useHonninNotesInputModal()

    // 打刻保存
    const { getDakokuData, syukkin, gaisyutsu, modori, taikin, kyuukei, isLoading } =
      useDakoku()

    const authStore = useAuthStore();

    const isInit = ref(false)

    onMounted(async () => {
      // 打刻対象はあくまでアクセス時点の記録なので過去の雇用契約に基づく就業場所に対しては打刻させないためshowOldKeiyakuはfalse
      await getOptionsByDakokuAndKoyouKeiyaku(null, null, null, false, false)
      if (syuugyouBasyoOptions.value.length > 0) {
        selectedSyuugyouBasyoOption.value = syuugyouBasyoOptions.value[0]
      }

      if(authStore.hasPermission(PermissionConst.GET_DAKOKU)){
        await getDakoku()
      }
      isInit.value = true
    });


    const changeSyuugyouBasyo = async () => {
      await getDakoku()
    };

    const getDakoku = async () => {
      if (selectedSyuugyouBasyoOption.value) {
        const koyouKeiyakuTimeId = selectedKoyouKeiyakuTimeOption.value?.val ?? null
        dakokuData.value = await getDakokuData(selectedSyuugyouBasyoOption.value.val, selectedSyuugyouBasyoOption.value.koyou_id, koyouKeiyakuTimeId)
        await getKoyouKeiyakuTime()
      }
    }

    const getKoyouKeiyakuTime = async () => {
      if (selectedSyuugyouBasyoOption.value) {
        await getKoyouKeiyakuTimeOrShiftOptionByDate(selectedSyuugyouBasyoOption.value.koyou_id, null)
        if(koyouKeiyakuTimeOptions.value.length > 0){
          let idx = koyouKeiyakuTimeOptions.value.findIndex((v) => { return v.val == dakokuData.value?.koyou_keiyaku_time_id })
          if(idx < 0){
            idx = 0
          }
          selectedKoyouKeiyakuTimeOption.value = koyouKeiyakuTimeOptions.value[idx]
        }else{
          selectedKoyouKeiyakuTimeOption.value = null
        }
      }
    }

    const syukkinDakoku = async () => {
      if (isSyounin()) {
        return
      }
      if (!dakokuData.value) {
        return
      }
      if (dakokuData.value.syukkin_datetime) {
        DialogService.warning({
          title: Message.ALREADY_DAKOKU.DIALOG_TITLE,
          text: Message.ALREADY_DAKOKU.TEXT,
        })
        return
      }

      if (dakokuData.value.taikin_datetime) {
        DialogService.warning({
          title: Message.DISABLED_SYUKKINU_DAKOKU_AFTER_TAIKIN.DIALOG_TITLE,
          text: Message.DISABLED_SYUKKINU_DAKOKU_AFTER_TAIKIN.TEXT,
        })
        return
      }

      DialogService.question({
        text: Message.CONFIRM_DAKOKU,
        confirmButtonText: 'はい',
        showCancelButton: true,
        cancelButtonText: 'いいえ',
      }).then(async (result: SweetAlertResult) => {
        if (!result.isConfirmed) {
          return
        }
        const koyouKeiyakuTimeId = selectedKoyouKeiyakuTimeOption.value?.val ?? null
        const res = await syukkin(selectedSyuugyouBasyoOption.value!.val, selectedSyuugyouBasyoOption.value!.koyou_id, koyouKeiyakuTimeId)
        if (!res) {
          DialogService.error({
            title: Message.ERROR_DAKOKU.DIALOG_TITLE,
            text: Message.ERROR_DAKOKU.TEXT
          })
          return
        }
        await getDakoku();
      })
    }

    const taikinDakoku = async () => {
      if (isSyounin()) {
        return
      }
      if (!dakokuData.value) {
        return
      }
      if (dakokuData.value.taikin_datetime) {
        DialogService.warning({
          title: Message.ALREADY_DAKOKU.DIALOG_TITLE,
          text: Message.ALREADY_DAKOKU.TEXT,
        })
        return
      }

      DialogService.question({
        text: Message.CONFIRM_DAKOKU,
        confirmButtonText: 'はい',
        showCancelButton: true,
        cancelButtonText: 'いいえ',
      }).then(async (result: SweetAlertResult) => {
        if (!result.isConfirmed) {
          return
        }
        const koyouKeiyakuTimeId = selectedKoyouKeiyakuTimeOption.value?.val ?? null
        const res = await taikin(selectedSyuugyouBasyoOption.value!.val, selectedSyuugyouBasyoOption.value!.koyou_id, koyouKeiyakuTimeId)
        if (!res) {
          DialogService.error({
            title: Message.ERROR_DAKOKU.DIALOG_TITLE,
            text: Message.ERROR_DAKOKU.TEXT
          })
          return
        }
        await getDakoku();
        if (dakokuData.value && !dakokuData.value.reported_kyuukei_times) {
          inputKyuukei();
        }
      })
    }

    const inputKyuukei = () => {
      if (isSyounin()) {
        return
      }
      if (!dakokuData.value) {
        return
      }
      if (dakokuData.value.reported_kyuukei_times) {
        DialogService.error({
          title: Message.ALREADY_DAKOKU.DIALOG_TITLE,
          text: Message.ALREADY_DAKOKU.TEXT,
        })
        return
      }

      // 休憩時間の入力対象となる日をセット（業務日時やAPI実行時だと対象日がずれるため退勤打刻日と合わせる）
      kyuukeiInputModal.openKyuukeiInputModal()
    }

    const gaisyutsuDakoku = async () => {
      if (isSyounin()) {
        return
      }
      if (!dakokuData.value) {
        return
      }


      if (dakokuData.value.gaisyutsu_datetime) {
        DialogService.warning({
          title: Message.ALREADY_DAKOKU.DIALOG_TITLE,
          text: Message.ALREADY_DAKOKU.TEXT,
        })
        return
      }

      if (dakokuData.value.taikin_datetime) {
        DialogService.warning({
          title: Message.DISABLED_GAISYUTSU_AND_MODORO_DAKOKU_AFTER_TAIKIN.DIALOG_TITLE,
          text: Message.DISABLED_GAISYUTSU_AND_MODORO_DAKOKU_AFTER_TAIKIN.TEXT,
        })
        return
      }

      if (dakokuData.value.modori_datetime) {
        DialogService.warning({
          title: Message.DISABLED_GAISYUTSU_DAKOKU_AFTER_MODORI.DIALOG_TITLE,
          text: Message.DISABLED_GAISYUTSU_DAKOKU_AFTER_MODORI.TEXT,
        })
        return
      }

      DialogService.question({
        text: Message.CONFIRM_DAKOKU,
        confirmButtonText: 'はい',
        showCancelButton: true,
        cancelButtonText: 'いいえ',
      }).then(async (result: SweetAlertResult) => {
        if (!result.isConfirmed) {
          return
        }
        const koyouKeiyakuTimeId = selectedKoyouKeiyakuTimeOption.value?.val ?? null
        const res = await gaisyutsu(selectedSyuugyouBasyoOption.value!.val, selectedSyuugyouBasyoOption.value!.koyou_id, koyouKeiyakuTimeId)
        if (!res) {
          DialogService.error({
            title: Message.ERROR_DAKOKU.DIALOG_TITLE,
            text: Message.ERROR_DAKOKU.TEXT
          })
          return
        }
        await getDakoku();
      })
    }

    const modoriDakoku = async () => {
      if (isSyounin()) {
        return
      }
      if (!dakokuData.value) {
        return
      }

      if (dakokuData.value.taikin_datetime) {
        DialogService.warning({
          title: Message.DISABLED_GAISYUTSU_AND_MODORO_DAKOKU_AFTER_TAIKIN.DIALOG_TITLE,
          text: Message.DISABLED_GAISYUTSU_AND_MODORO_DAKOKU_AFTER_TAIKIN.TEXT,
        })
        return
      }

      if (dakokuData.value.modori_datetime) {
        DialogService.warning({
          title: Message.ALREADY_DAKOKU.DIALOG_TITLE,
          text: Message.ALREADY_DAKOKU.TEXT,
        })
        return
      }

      DialogService.question({
        text: Message.CONFIRM_DAKOKU,
        confirmButtonText: 'はい',
        showCancelButton: true,
        cancelButtonText: 'いいえ',
      }).then(async (result: SweetAlertResult) => {
        if (!result.isConfirmed) {
          return
        }
        const koyouKeiyakuTimeId = selectedKoyouKeiyakuTimeOption.value?.val ?? null
        const res = await modori(selectedSyuugyouBasyoOption.value!.val, selectedSyuugyouBasyoOption.value!.koyou_id, koyouKeiyakuTimeId)
        if (!res) {
          DialogService.error({
            title: Message.ERROR_DAKOKU.DIALOG_TITLE,
            text: Message.ERROR_DAKOKU.TEXT
          })
          return
        }
        await getDakoku()
      })
    }


    const kyuukeiInputClose = async (val: any) => {
      kyuukeiInputModal.closeKyuukeiInputModal()
      if (val) {
        await getDakoku()
        if (isNull(dakokuData.value?.honnin_notes) || dakokuData.value?.honnin_notes === '') {
          // honninNotesInputModal.openHonninNotesInputModal()
        }
      }
    }

    const kyuukeiInputCancel = async () => {
      kyuukeiInputModal.closeKyuukeiInputModal()
    }

    const selectOtherSyuugyouBasyo = async (syuugyoBasyo: SyuugyouBasyoOption | null) => {
      syuugyouBasyoModal.closeSyuugyouBasyoModal()
      if (syuugyoBasyo) {
        selectedSyuugyouBasyoOption.value = syuugyoBasyo
        syuugyouBasyoOptions.value.push(syuugyoBasyo)
        await getDakoku()
      }
      // TODO: ここで選んだものを打刻したら「打刻を行う就業場所」にその就業場所を追加する
    }

    const honninNotesInputSend = async () => {
      honninNotesInputModal.closeHonninNotesInputModal()
      await getDakoku()
    }

    const honninNotesInputCancel = async () => {
      honninNotesInputModal.closeHonninNotesInputModal()
    }

    const isSyounin = () => {
      if (isSyouninDakoku.value) {
        DialogService.warning({
          title: Message.ALREADY_DAKOKU_SYOUNIN.DIALOG_TITLE,
          text: Message.ALREADY_DAKOKU_SYOUNIN.TEXT,
        })
        return true
      }
      return false
    }

    return {
      displayData,
      syukkinDakoku,
      gaisyutsuDakoku,
      modoriDakoku,
      taikinDakoku,
      kyuukei,
      changeSyuugyouBasyo,
      isLoading,
      dakokuData,
      kyuukeiInputModalRef: kyuukeiInputModal.kyuukeiInputModalRef,
      kyuukeiInputModalParts: kyuukeiInputModal.kyuukeiInputModalParts,
      kyuukeiInputClose,
      kyuukeiInputCancel,
      inputKyuukei,
      getDakoku,
      OptionConst,
      RouterConst,
      syuugyouBasyoOptions,
      selectedSyuugyouBasyoOption,
      targetDate,
      authStore,
      PermissionConst,
      selectOtherSyuugyouBasyo,
      syuugyouBasyoModal,
      syuugyouBasyoModalRef: syuugyouBasyoModal.SyuugyouBasyoModalRef,
      isInit,
      honninNotesInputModal,
      honninNotesInputModalRef: honninNotesInputModal.honninNotesInputModalRef,
      honninNotesInputModalParts: honninNotesInputModal.honninNotesInputModalParts,
      honninNotesInputSend,
      honninNotesInputCancel,
      isSyouninDakoku,
      howWeek,
      selectedKoyouKeiyakuTimeOption,
      koyouKeiyakuTimeOptions,
    }
  },
  components: {
    'kyuukei-nyuuryoku': KyuukeiNyuuryoku,
    'select-syuugyoubasyo': SelectSyuugyoubasyo,
    'honnin-notes-input': HonninNotesInput
  },
});
</script>

<style lang="scss" scoped>
@import '@scss/components/dakoku-panel.scss';
</style>
